import OneSignal from 'react-onesignal';
import React, { useState, useReducer, useEffect, useCallback, useMemo } from "react";
import "./Faculty.css";
import Form from 'react-bootstrap/Form'
import { useForm } from "react-hook-form";
import { useImmer } from "use-immer";
import UppyModal from '../UppyModal/UppyModal'
import { useFacultyOptionsStore } from "../../stores";
import constants from "../../utils/constants"
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import withReactContent from "sweetalert2-react-content";
import { useUserStore, useAppStore } from '../../stores';
import { handleXhrError } from '../../utils';
//toast
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

//sweetalert
const MySwal = withReactContent(Swal);
const { FILE_CATEGORY, EXAM } = constants();
const Student = () => {
  const defaultFieldValues = {
    degree: "none",
    branch: "none",
    section: "none",
    subject: "none",
    sem: "none",
    year: "none",
    category: FILE_CATEGORY.STUDY_MATERIALS,
    exam: EXAM.SEM,
    batch: "none",
    id: "none",
    name: "none",
    mimeType: "none",
    url: "none"
  };
  const { register, handleSubmit, getValues, setValue, watch, formState: { errors }, unregister, reset } = useForm({ shouldUnregister: false, defaultValues: defaultFieldValues, shouldUseNativeValidation: true });
  const me_user = useUserStore(state => state.data);
  const showLoading = useAppStore(state => state.showLoading);
  const hideLoading = useAppStore(state => state.hideLoading);
  const onSubmit = (data) => {
    showLoading();
    console.log(data.section);
    if (Object.values(data).includes("none")) {
      toast.error("Please select all fields", toastOptions);
      hideLoading();
      return;
    }
    window.$.ajax({
      type: "post",
      url: "/api/file/job",
      xhrFields: {
        withCredentials: true,
      },
      data: {
        ...data,
        sections: data.section
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        setValue("url", "");
        setValue("name", "");
        setValue("mimeType", "");
        setValue("id", "");
        hideLoading();
        MySwal.fire(response.message);
      },
      statusCode: {

        404: function () {
          toast.error("page not found", toastOptions);
          hideLoading();
        },
        400: function (res) {
          hideLoading();
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          hideLoading();
        })
      },
    });
    console.log(data);
  }
  const duration = '4';
  const [show, setShow] = useState(false);
  const addFileHandle = () => {
    setShow(true)
  }
  const addAllCourses = useFacultyOptionsStore((state) => state.addAllCourses);
  const courses = useFacultyOptionsStore((state) => state.courses);
  const getDegrees = useFacultyOptionsStore((state) => state.getDegrees);
  const getBranches = useFacultyOptionsStore((state) => state.getBranches);
  const getYears = useFacultyOptionsStore((state) => state.getYears);
  const getSems = useFacultyOptionsStore((state) => state.getSems);
  const getSections = useFacultyOptionsStore((state) => state.getSections);
  const getSubjects = useFacultyOptionsStore((state) => state.getSubjects);
  const getCurrentBatch = useFacultyOptionsStore((state) => state.getCurrentBatch);
  const degreeMemo = useMemo(() => watch("degree", "none"), [watch("degree", "none")]);
  const branchMemo = useMemo(() => watch("branch", "none"), [watch("branch", "none")]);
  const yearMemo = useMemo(() => watch("year", "none"), [watch("year", "none")]);
  const sectionMemo = useMemo(() => watch("section", "none"), [watch("section", "none")]);
  const semMemo = useMemo(() => watch("sem", "none"), [watch("sem", "none")]);
  const subjectMemo = useMemo(() => watch("subject", "none"), [watch("subject", "none")]);
  const curBatchMemo = useMemo(() => getCurrentBatch({ year: yearMemo, section: sectionMemo }).pop(), [yearMemo, sectionMemo]);
  const onSuccess = (result) => {
    if (result.failed.length > 1) {
      alert("Failed to upload");
      console.log(result);
      return;
    }
    setValue("url", result.successful[0].downloadUrl);
    setValue("name", result.successful[0].name);
    setValue("mimeType", result.successful[0].type);
    setValue("id", result.successful[0].refId);
  }
  const onClose = () => {
    setShow(false);
  }
  useEffect(() => {
    showLoading();
    fetch("/api/faculty/options")
      .then((res) => {
        hideLoading();
        if (res.status !== 200) {
          res.json()
            .then(r => console.log(r.message))
        }
        else {
          res.json().then(response => {
            console.log(response);
            addAllCourses(response.courses);
          })
        }
      })
  }, [])
  // oneSignal init
  useEffect(() => {
    // OneSignal.init({
    //   appId: "b3def638-d17f-46f1-ad4e-6f739ef230fa"
    // });
    // OneSignal.setEmail(me_user.email)
    //   .then(function (emailId) {
    //     // Callback called when email have finished sending
    //     console.log("emailId: ", emailId);
    //     OneSignal.setSubscription(true).then(() => {
    //       OneSignal.showSlidedownPrompt().then((done, reject) => {
    //         console.log(done, reject);
    //       })
    //     })

    //   });
  }, []);
  const Degrees = useCallback(() => {
    const degs = getDegrees();
    return degs.map((o, index) => {
      return (<option selected={index === 0} value={o._id}>{o.name}</option>)
    })
  }, [])
  const Branches = useCallback(() => {
    const brs = getBranches(degreeMemo);
    return brs.map((o, index) => {
      return (<option value={o._id}>{o.name}</option>)
    })
  }, [degreeMemo])
  const Years = useCallback(() => {
    const yrs = getYears({ branch: branchMemo, degree: degreeMemo });
    return yrs.map((o, index) => {
      return (<option key={index} value={o}>{o}</option>)
    })
  }, [branchMemo, degreeMemo])
  const Sems = useCallback(() => {
    const sms = getSems({ branch: branchMemo, degree: degreeMemo, year: yearMemo });
    return sms.map((o, index) => {
      return (<option key={index} value={o}>{o}</option>)
    })
  }, [branchMemo, degreeMemo, yearMemo])
  const Subjects = useCallback(() => {
    const subs = getSubjects(sectionMemo);
    return subs.map((o, index) => {
      return (<option value={o._id}>{o.name}</option>)
    })
  }, [sectionMemo])
  const Sections = useCallback(() => {
    const secs = getSections({ branch: branchMemo, year: yearMemo, sem: semMemo });
    return secs.map((o, index) => {
      return (<option value={o._id}>{o.name}</option>)
    })
  }, [branchMemo, yearMemo, semMemo])
  const Batches = useCallback(() => {
    return getCurrentBatch({ year: yearMemo, section: sectionMemo }).map((o, index) => {
      return (<option key={index} value={o}>{o}</option>)
    })
  }, [yearMemo, sectionMemo])
  if (courses.length < 1) {
    return (<>
      {/* <ToastContainer /> */}
    </>)
  }
  return (
    <div className="maincontainerF">
      <UppyModal show={show} onSuccess={onSuccess} onClose={onClose} />
      {/* <ToastContainer /> */}
      <form className="col-md-6 studentform" onSubmit={handleSubmit(onSubmit)}>
        {/* <div class='onesignal-customlink-container'></div> */}
        <pre className="row">
          {/* {
            JSON.stringify(watch(), null, 4)
          } */}
        </pre>
        <div className="row">
          {/* file data after uploading hidden*/}
          <input type="hidden" {...register("url")} />
          <input type="hidden" {...register("mimeType")} />
          {/* <input type="hidden" {...register("name")} /> */}
          <input type="hidden" {...register("id")} />

          <div className="form-group col-md-8">
            <label>Category</label>
            <select
              className="form-select categoryOptions"
              aria-label="Default select example"
              {...register("category")}
            >
              <option value={FILE_CATEGORY.STUDY_MATERIALS}>Study material</option>
              <option value={FILE_CATEGORY.QUESTIONS}>Question papers</option>
              <option value={FILE_CATEGORY.ASSIGNMENTS}>Assignments</option>
            </select>
          </div>
          <div className="form-group col-md-4">
            <label>Exam</label>
            <Form.Select
              {...register("exam")}
            >
              <option value={EXAM.MID1}>Mid1</option>
              <option value={EXAM.MID2}>Mid2</option>
              <option value={EXAM.SEM}>Semester</option>
            </Form.Select>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-4">
            <label>Degree</label>
            <div className="row m-0 ">
              <Form.Select
                {...register("degree", {
                  onChange: (e) => {
                    setValue("branch", "none");
                    setValue("year", "none");
                    setValue("sem", "none");
                    setValue("subject", "none");
                    setValue("section", "none");
                    setValue("batch", "none");
                  }
                })}
              >
                <Degrees />
              </Form.Select>
            </div>
          </div>
          <div className="form-group col-md-4">
            <label>Branch</label>
            <Form.Select
              {...register("branch", {
                onChange: (e) => {
                  setValue("year", "none");
                  setValue("sem", "none");
                  setValue("subject", "none");
                  setValue("section", "none");
                  setValue("batch", "none");
                }
              })}
            >
              <Branches />
            </Form.Select>
          </div>
          <div className="form-group col-md-4">
            <label>Year</label>
            <Form.Select {...register("year", {
              onChange: (e) => {
                setValue("sem", "none");
                setValue("subject", "none");
                setValue("section", "none");
                setValue("batch", "none");
              }
            })
            } >
              <Years />
            </Form.Select>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-4">
            <label>semester</label>
            <Form.Select {...register("sem", {
              onChange: (e) => {
                setValue("subject", "none");
                setValue("section", "none");
                setValue("batch", "none");
              }
            })}
            >
              <Sems />
            </Form.Select>
          </div>
          <div className="form-group col-md-4">
            <label>Section</label>
            <Form.Select {...register("section", {
              onChange: (e) => {
                setValue("subject", "none");
                setValue("batch", getCurrentBatch({ year: yearMemo, section: e.target.value }).pop());
              }
            })}
            >
              <Sections />
            </Form.Select>
          </div>
          <div className="form-group col-md-4">
            <Form.Label>Current Batch</Form.Label>
            <div className="row m-0 ">
              <input className="form-control" type="text" readOnly {...register("batch")} />
              {/* <Batches /> */}
            </div>
          </div>
          {/* <div className="form-group col-md-4">
            <label>Select Batch</label>
            <div className="row m-0 ">
              <Form.Select>
                {
                  Array.from(duration).map((o, index) => {
                    <option value={index}>R-{details.batch - details.year + 1 - index}</option>
                  })
                }
              </Form.Select>
            </div>
          </div> */}
        </div>
        <div className="form-group">
          <label>Subject</label>
          <Form.Select {...register("subject")}
          >
            <Subjects />
          </Form.Select>
        </div>
        <div class="form-group">
          <label for="formFile" class="form-label">
            Add file
          </label>
          <div class="input-group mb-3">
            <button class="btn btn-outline-secondary" type="button" id="UppyfileUpload" onClick={addFileHandle}>Add files</button>
            <input readOnly={watch("url").length < 1 || watch("url") === 'none' ? true : false} type="text" {...register("name")} class="form-control" placeholder="No file chosen" aria-label="File upload file name" aria-describedby="UppyfileUpload" />
          </div>
          <sub>Format : Subject_name/Unit1.ppt (can add multiple units at once)</sub>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button className="SearchBtn col-md-4 m-2">Upload</button>
        </div>
      </form>
    </div>
  );
};

export default Student;
